import { query, collection, orderBy, onSnapshot, setDoc, doc, addDoc, deleteDoc, serverTimestamp, where } from "firebase/firestore";
import { db, getCompanyId, getCurrentUser, getCurrentUserUID, sendError } from "./firebase";

import { CallDirectory, CallDirectoryItem } from '@awesome-cordova-plugins/call-directory'
import { Capacitor } from "@capacitor/core";

import { Contacts } from '@capacitor-community/contacts'

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotUserList: any[] = [];
//var additionalList: any[] = [];
//var additionalMap = new Map();
var lastSnapshotUserMap = new Map();
var lastSnapshotMap = new Map();
var clientByPhoneMap = new Map();
var phoneContacts = new Map();

async function getPhoneContacts() {
    Contacts.getContacts().then(result => {
        for (const contact of result.contacts) {
            for (const number of contact.phoneNumbers) {
                var n = number.number;
                if (n !== undefined) {
                    n = n.replace(/[^0-9]/g, "");
                    if (n.length === 9) {
                        n = "0048" + n;
                    }
                    if (n.length === 11) {
                        n = "00" + n;
                    }
                    if (n.length === 13) {
                        phoneContacts.set(n, contact.displayName);
                    }
                }
            }
        }
        //console.log(phoneContacts);
    });
}

async function updateCallDirectorry(callDirectory: any) {
    if (Capacitor.getPlatform() === "ios") {
        try {
            if (await CallDirectory.isAvailable()) {
                //console.log("CallDirectory", callDirectory);
                try {
                    await CallDirectory.removeAllIdentification();
                } catch (err) {
                    console.log("CallDirectory.removeAllIdentification error => " + err);
                    sendError(err + "");
                }
                await CallDirectory.addIdentification(callDirectory);
                await CallDirectory.reloadExtension();
            } else {
                console.log("CallDirectory not available");
            }

        } catch (err) {
            console.log("CallDirectory error => " + err);
            sendError(err + "");
        }
    }
}

export function registerClientSnapshotListener() {
    if (snapshotListener !== null) {
        return;
    }
    if (Capacitor.getPlatform() === "ios") {
        getPhoneContacts();
    }

    const q = query(collection(db, 'companies/' + getCompanyId() + '/clients'), orderBy("surname"), orderBy("name"));
    //const q = query(collection(db, 'companies/' + getCompanyId() + '/clients'), where("userId", "in", [...[getCurrentUserUID()], ...getCurrentUser().clientAccess]));
    const userIds = [...[getCurrentUserUID()], ...getCurrentUser().clientAccess];
    //console.log("register clientListener");
    snapshotListener = onSnapshot(q, async (data: any) => {
        var list: {
            id: any; name: string, surname: string, email: string, phone: string, birthday: string, active: boolean, address: string, zipCode: string, city: string, smsTemplate: string,
            gname: string, gsurname: string, gemail: string, gphone: string, gaddress: string, gzipCode: string, gcity: string, gsmsTemplate: string,
            comments: string, pesel: string,
            iname: string, iaddress: string, izipCode: string, icity: string, icountry: string, ivat: string,
            commentList: [], created: any, updated: any, userId: string, 
            permissions: Map<String, String>;

        }[] = [];
        lastSnapshotUserMap.clear();
        lastSnapshotMap.clear();
        clientByPhoneMap.clear();
        //additionalList.length = 0;
        var callDirectory: CallDirectoryItem[] = [];
        data.forEach(function (doc: any) {
            const d = doc.data();
            //resource musi być stringiem
            const e = {
                id: doc.id, name: d.name ?? '', surname: d.surname ?? '', email: d.email ?? '', phone: d.phone ?? '', birthday: d.birthday ?? '', active: d.active ?? true, address: d.address ?? '', zipCode: d.zipCode ?? '', city: d.city ?? '', smsTemplate: d.smsTemplate ?? '',
                gname: d.gname ?? '', gsurname: d.gsurname ?? '', gemail: d.gemail ?? '', gphone: d.gphone ?? '', gaddress: d.gaddress ?? '', gzipCode: d.gzipCode ?? '', gcity: d.gcity ?? '', gsmsTemplate: d.gsmsTemplate ?? '',
                comments: d.comments ?? '', pesel: d.pesel ?? '',
                iname: d.iname ?? '', iaddress: d.iaddress ?? '', izipCode: d.izipCode ?? '', icity: d.icity ?? '', icountry: d.icountry ?? '', ivat: d.ivat ?? '',
                commentList: d.commentList ?? [], created: d.created, birthdayPlace: d.birthdayPlace ?? '', school: d.school ?? '', schoolClass: d.schoolClass ?? '', updated: d.updated, userId: d.userId,
                permissions: d.permissions ?? {}
            }
            // if(additionalMap.has(e.id)){
            //     additionalList.push(e);
            // }
            //if (userIds.includes(e.userId) || (e.permissions.hasOwnProperty(getCurrentUser().id) && e.permissions[getCurrentUser().id] !== 'none')) {
            //wyłączam ograniczenie klientów
                list.push(e);
                lastSnapshotUserMap.set(doc.id, e);
            //}
            lastSnapshotMap.set(doc.id, e);
            if (e.phone.length >= 9) {
                var p = e.phone;
                if (p.length === 9) {
                    p = "0048" + p;
                }
                if (p.length === 11) {
                    p = "00" + p
                }
                if (!clientByPhoneMap.has(p)) {
                    callDirectory.push({ label: e.surname + " " + e.name, number: p.substring(2) })
                }
                clientByPhoneMap.set(p, e);
            }
            if (e.gphone.length >= 9) {
                var p = e.gphone;
                if (p.length === 9) {
                    p = "0048" + p;
                }
                if (p.length === 11) {
                    p = "00" + p
                }
                if (p.length === 13 && !clientByPhoneMap.has(p)) {
                    callDirectory.push({ label: e.gsurname + " " + e.gname, number: p.substring(2) })
                }
                clientByPhoneMap.set(p, e);
            }
        });
        updateCallDirectorry(callDirectory);
        list = list.sort((a: any, b: any) => {
            var r = a.surname.localeCompare(b.surname);
            if (r === 0) {
                return a.name.localeCompare(b.name)
            }
            return r;
        })
        lastSnapshotUserList = list;
        //console.log("clients", list);
        listeners.forEach(callback => {
            callback(list);
        });

    }, (err) => {
        console.log("onClientChange error => " + err.message);
        sendError(err.message);
    })
}

export async function unregisterClientSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister unregisterClientSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addClientListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotUserList.length > 0) {
        callback(lastSnapshotUserList);
    }
}

export async function addClientEventsListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotUserList.length > 0) {
        callback(lastSnapshotUserList);
    }
}

export async function addClient(data: any) {
    var saveData = {
        name: data.name ?? '',
        surname: data.surname ?? '',
        email: data.email ?? '',
        phone: data.phone ?? '',
        smsTemplate: data.smsTemplate ?? '',
        birthday: data.birthday ?? '',
        pesel: data.pesel ?? '',
        active: data.active ?? true,
        address: data.address ?? '',
        zipCode: data.zipCode ?? '',
        city: data.city ?? '',
        birthdayPlace: data.birthdayPlace ?? '',
        school: data.school ?? '',
        schoolClass: data.schoolClass ?? '',


        gname: data.gname ?? '',
        gsurname: data.gsurname ?? '',
        gemail: data.gemail ?? '',
        gphone: data.gphone ?? '',
        gsmsTemplate: data.gsmsTemplate ?? '',
        gaddress: data.gaddress ?? '',
        gzipCode: data.gzipCode ?? '',
        gcity: data.gcity ?? '',

        comments: data.comments ?? '',

        iname: data.iname ?? '',
        iaddress: data.iaddress ?? '',
        izipCode: data.izipCode ?? '',
        icity: data.icity ?? '',
        icountry: data.icountry ?? '',
        ivat: data.ivat ?? '',

        commentList: data.commentList ?? ''

    };

    if (data.id !== null && data.id !== undefined) {
        //@ts-ignore
        saveData.lastUpdated = data.updated;
        //@ts-ignore
        saveData.updated = serverTimestamp();
        try {
            await setDoc(doc(db, 'companies/' + getCompanyId() + '/clients', data.id), saveData, { merge: true });
            return true;
        } catch (e) {
            console.error(e);
            sendError("Nie mozna poprawić Klienta!");
        }

    } else {

        //@ts-ignore
        saveData.created = serverTimestamp();
        //@ts-ignore
        saveData.updated = serverTimestamp();
        //@ts-ignore
        saveData.lastUpdated = serverTimestamp();
        //@ts-ignore
        saveData.userId = getCurrentUserUID();
        try {
            await addDoc(collection(db, 'companies/' + getCompanyId() + '/clients'), saveData);
            return true;
        } catch (e) {
            console.error(e);
            sendError("Nie mozna dodać Wydarzenia!");
        }
    }
    return false;
}

export async function removeClient(id: string) {
    try {
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/clients', id));
        return true;
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć Klienta!");
    }
    return false;
}

export function getClients() {
    return lastSnapshotUserList;
}

export function getClient(id: string) {
    var c = lastSnapshotMap.get(id);   
    return lastSnapshotMap.get(id);

}

export function getClientByPhone(number: string) {
    return clientByPhoneMap.get(number);

}

export function getClientNameFromPhoneContacts(number: string) {
    return phoneContacts.get(number);
}